import React from "react";
import { ASSOC } from "@/lib/data";

export default function LegalPage({ kind }) {
  const mentions = (
    <>
      <h1 className="font-heading text-4xl font-black tracking-tighter">Mentions légales</h1>
      <div className="mt-6 space-y-4 text-neutral-700 font-body">
        <p><strong>Éditeur du site :</strong> Association {ASSOC.name}, {ASSOC.address}.</p>
        <p><strong>Présidente :</strong> {ASSOC.president}.</p>
        <p><strong>Téléphone :</strong> {ASSOC.phone}</p>
        <p><strong>Emails :</strong> {ASSOC.emails.join(" · ")}</p>
        <p><strong>Hébergement :</strong> serveurs sécurisés — informations à compléter.</p>
      </div>
    </>
  );
  const privacy = (
    <>
      <h1 className="font-heading text-4xl font-black tracking-tighter">Politique de confidentialité</h1>
      <div className="mt-6 space-y-4 text-neutral-700 font-body">
        <p>Les données saisies dans nos formulaires (contact, inscription) sont utilisées uniquement pour répondre à votre demande et ne sont jamais transmises à des tiers.</p>
        <p>Vous pouvez demander à tout moment leur suppression en écrivant à {ASSOC.emails[0]}.</p>
        <p>Le site n’utilise pas de cookies publicitaires.</p>
      </div>
    </>
  );
  return (
    <div className="max-w-3xl mx-auto px-4 sm:px-6 py-16 sm:py-24">
      {kind === "mentions" ? mentions : privacy}
    </div>
  );
}
